import { Button, Input, ToastMessage } from '@cokitchen/cokitchen-components';
import FileUploaderWithCropTool from 'components/base/file-uploader/crop-tool';
import LocalModal from 'components/base/local-modal';
import SelectDropdown from 'components/base/select-dropdown';
import useDashboardContext from 'contexts/dashboard.context';
import useAxios from 'hooks/useAxios';
import { CokitchenFCBBrandResponse } from 'models/brand-details.model';
import { BrandType, EditBrandType } from 'models/brand.model';
import React, { useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import { apiService } from 'services/base.service';
import { handleApiError } from 'utils/functions';

const EditBrandModal = ({
  show,
  onClose,
  brand,
  updateCompanyBrand
}: {
  show: boolean;
  onClose: () => void;
  brand: null | BrandType;
  updateCompanyBrand: (name: string, images: string[]) => void;
}) => {
  const { activeCompany } = useDashboardContext();

  const [selectedCokitchen, setSelectedCokitchen] = useState({ id: brand?.cokitchen_id, name: '' });

  const { fetchData, response: FCBBrandType } = useAxios<CokitchenFCBBrandResponse>({
    url: 'company/cokitchen'
  });

  const companyId = activeCompany.id;

  const [formData, setFormData] = useState({
    name: brand?.name,
    images: brand?.images
  } as EditBrandType);

  const setBrandImage = (data: string[]) => {
    setFormData({ ...formData, images: data });
  };

  const EditBrand = async () => {
    if (!companyId) return;
    const data = {
      name: formData.name,
      image: formData.images[0],
      cokitchen_id: selectedCokitchen?.id
    };
    try {
      const res = await apiService.put(`company/brand/${brand?.id}`, { data });
      if (res) {
        toast(<ToastMessage type='success' message='Brand edited successfully' />);
        onClose();
        updateCompanyBrand(formData.name, formData.images);
      }
    } catch (err) {
      handleApiError(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  //---- selected brand type and it's listing-----
  const FCBBrandTypeOptions = useMemo(
    () =>
      FCBBrandType?.data?.data?.map((fcb) => ({ id: fcb?.id, name: fcb?.name })) ?? [
        {
          id: '',
          name: 'N/A'
        }
      ],
    [FCBBrandType]
  );

  const selectedFCBBrandTypeObj = FCBBrandType?.data?.data?.find(
    (fcb) => fcb?.id === selectedCokitchen?.id
  );

  return (
    <LocalModal
      isOpen={show}
      title='Edit Brand Details'
      onRequestClose={() => onClose()}
      footer={
        <div className='flex gap-5 justify-end '>
          <Button
            onClick={onClose}
            className='w-[139px] h-[41px] !bg-[#F2F2F2] !border-[#F2F2F2] !text-[#2E3031] text-sm'
            color='gray'
            small
            variant='block'>
            Cancel
          </Button>
          <Button
            className='w-[139px] h-[41px] text-sm'
            color='primary'
            small
            variant='block'
            onClick={EditBrand}>
            Confirm
          </Button>
        </div>
      }>
      <div className='flex flex-col gap-7'>
        <Input
          design='bordered'
          type='text'
          label='Brand name'
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          placeholder='e.g FCBkitchen'
        />
        <p className='mb-[6px] text-[#2E3031] font-medium'>Brand image</p>
        <FileUploaderWithCropTool
          aspectRatio={2 / 1}
          fileUrls={formData.images}
          setFileUrls={setBrandImage}
        />

        <SelectDropdown
          label=' Select CoKitchen'
          value={selectedFCBBrandTypeObj?.name}
          setValue={(option) => {
            setSelectedCokitchen({ id: option?.id, name: option?.name });
          }}
          placeholder='Choose a Cokitchen'
          options={FCBBrandTypeOptions}
        />
      </div>
    </LocalModal>
  );
};

export default EditBrandModal;
